import { buildTileLoggingData } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/EventLogging/buildLoggingData";
import { ComponentLoggingEventParams } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { ITile } from "@faire/web-api--source/indigofair/data/ITile";
import React, { useMemo } from "react";

import { getTileComponent } from "./__internal__/getTileComponent";

export const SDUITileRenderer = ({
  tileElement,
  loggingData,
}: {
  tileElement: ITile;
  loggingData: ComponentLoggingEventParams;
  className?: string;
  style?: React.CSSProperties;
} & Partial<Pick<HTMLDivElement, "ariaHidden">>) => {
  const TileComponent = getTileComponent(tileElement, loggingData);
  const { logging_data } = tileElement;
  const tileLoggingData = useMemo(
    () => buildTileLoggingData(loggingData, logging_data),
    [loggingData, logging_data]
  );

  if (TileComponent === undefined) {
    return null;
  }

  return (
    <TileComponent tileElement={tileElement} loggingData={tileLoggingData} />
  );
};
